/* eslint-disable jsx-a11y/no-autofocus */

import {
  ChangeEventHandler,
  FC,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { range } from 'ramda';

import {
  Digit,
  DigitContainer,
  HiddenTextInput,
  TokenInputContainer,
} from './styles';

const NON_NUMERIC_REGEX = /\D/g;
const TOKEN_FULL_LENGTH = 9;

interface TokenInputProps {
  onTokenFilled: (token: string) => void;
}

const TokenInput: FC<TokenInputProps> = ({ onTokenFilled }) => {
  const [token, setToken] = useState('');
  const [isTokenInputFocused, setIsTokenInputFocused] = useState<boolean>(true);

  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      const cleanValue = event.target.value.replace(NON_NUMERIC_REGEX, '');
      setToken(cleanValue);
    },
    [setToken],
  );

  useEffect(() => {
    if (token.length === TOKEN_FULL_LENGTH) {
      onTokenFilled(token);
      setToken('');
    }
  }, [token, onTokenFilled]);

  const focusOnInput = useCallback(() => {
    if (inputRef.current !== null) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  return (
    <TokenInputContainer>
      {range(0, TOKEN_FULL_LENGTH).map((i) => (
        <DigitContainer
          focused={isTokenInputFocused && i === token.length}
          key={i}
          onClick={focusOnInput}
        >
          <Digit>{token[i]}</Digit>
        </DigitContainer>
      ))}
      <HiddenTextInput
        autoFocus
        maxLength={TOKEN_FULL_LENGTH}
        onBlur={() => setIsTokenInputFocused(false)}
        onChange={handleChange}
        onFocus={() => setIsTokenInputFocused(true)}
        ref={inputRef}
        value={token}
      />
    </TokenInputContainer>
  );
};

export default TokenInput;
